import React, { useEffect, useRef, useState } from 'react';
import { ButtonIconRound } from '../../../components/ui';
import NewSubjectModal from '../../../components/NewSubjectModal';
import NewGroupModal from '../../../components/NewGroupModal';

const NewButton = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [showPopOver, setShowPopOver] = useState(false);
  const [showNewSubjectModal, setShowNewSubjectModal] = useState(false);
  const [showNewGroupModal, setShowNewGroupModal] = useState(false);

  const handleClickOutside = (event: Event) => {
    const current = wrapperRef.current;
    if (current && wrapperRef.current && !current.contains(event.target as HTMLDivElement)) {
      setShowPopOver(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <div className="relative" ref={wrapperRef}>
      <ButtonIconRound
        onClick={() => setShowPopOver(true)}
        name="plus"
        iconSize={30}
        iconViewBox={30}
        data-testid="new-button"
      />
      {showPopOver && (
        <div className="bg-white shadow-1 absolute top-0 right-0 br2 blue hover-navy tc f6 w4">
          <button
            className="pointer blue hover-navy w-100 pv2 ph3 bb b--light-gray"
            onClick={() => {
              setShowPopOver(false);
              setShowNewGroupModal(true);
            }}
            data-testid="new-group-button"
          >
            New Group
          </button>
          <button
            className="pointer blue hover-navy w-100 pv2 ph3"
            onClick={() => {
              setShowPopOver(false);
              setShowNewSubjectModal(true);
            }}
            data-testid="new-subject-button"
          >
            New Subject
          </button>
        </div>
      )}

      {showNewSubjectModal && <NewSubjectModal closeModal={() => setShowNewSubjectModal(false)} />}
      {showNewGroupModal && <NewGroupModal closeModal={() => setShowNewGroupModal(false)} />}
    </div>
  );
};

export default NewButton;
